// removed by extract-text-webpack-plugin
module.exports = {"buttons":"src-pages-developers-style----general-module---buttons---3Z4G1 breakPointS-inline","margin":"src-pages-developers-style----general-module---margin---2_iJx marginBottom-m breakPointS-marginBottom-0 breakPointS-marginRight-m"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/developers/style/general.module.css
// module id = 161
// module chunks = 41987919009899 116229058454702 175145265529644